import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { showToast } from "../toastify/Toast";

export const handleApiError = (error: unknown, defaultMessage = "Something went wrong. Please try again.") => {
    let errorMessage = defaultMessage;

    if (error && typeof error === "object" && "status" in error) {
        const err = error as FetchBaseQueryError;

        if (err.data && typeof err.data === "object") {
            const data = err.data as { success?: boolean; message?: string };
            if (data.message) {
                errorMessage = data.message;
            }
        }
    }

    else if (error instanceof Error) {
        errorMessage = error.message;
    }

    showToast(errorMessage, "error");
}